<template>
    <div class="chart"></div>
</template>

<style lang="less" scoped>
.chart {
    height: 100%;
}
</style>

<script>
export default {
    name: '',
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            myChart: null
        }
    },
    watch: {
    // 监听 data 属性的变化，深度监听
    data: {
      deep: true,
      handler() {
        this.setChart(); // 数据更新时重新渲染图表
      }
    }
  },
    methods: {
        setChart() {
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                title:

                    {
                        text: this.data.title,
                        top: "5%",
                        left: '5%',
                        textStyle: {
                            color: '#fff',
                            fontSize: 12,
                        }
                    },
                legend:
                    {
                        data: [
                            {name: this.data.data[0].name, icon: 'circle'},
                            {name: this.data.data[1].name, icon: 'circle'},
                        ],
                        left: "center",
                        top: "17%",
                        orient: 'horizontal',
                        itemWidth: 7,
                        itemHeight: 7,
                        itemGap: 10,
                        textStyle: {
                            color: '#67C3D6',
                            fontSize: 12
                        }
                    },
                grid:
                    {
                        left: "15%",
                        top: '35%',
                        right: '15%',
                        bottom: '15%'
                    },
                xAxis:
                    {
                        axisLine: {
                            lineStyle: {
                                color: '#2B427F'
                            }
                        },
                        axisLabel: {
                            color: '#0DF5F8',
                            fontSize: 12,
                            interval: 0,
                        },
                        axisTick: {
                            inside: true,
                            alignWithLabel: true,
                            interval: 0,
                            color: '#2B427F'
                        },
                        data: ['香菇', '平菇', '金针菇', '杏鲍菇', '白玉菇']
                    },


                yAxis:[                     
                    {
                        type: 'value',
                        position: 'left',
                        axisLine: {
                            show: false,
                        },
                        axisLabel: {show: true,
                            textStyle: {
                            color:'#61B9C8'
                            }
                        },
                        axisTick: {show: false},
                        splitLine: {
                           show: false,
                        },
                        name: '(吨)',
                        nameTextStyle: {
                            color: '#61B9C8',
                            fontSize: 11,
                            align: 'right',
                        },

                    },
                    {
                        type: 'value',
                        position: 'right',
                        axisLine: {
                            show: false,
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                            color:'#61B9C8'
                            }
                        },
                        axisTick: {show: false},
                        splitLine: {
                            show: false,

                        }

                    },
                ],   
                series: [
                    {
                        type: 'bar',
                        name: this.data.data[0].name,
                        barWidth: 6,
                        barGap: 0,
                        yAxisIndex: 0, //
                        itemStyle: {
                            borderRadius: 2,
                            color: this.data.data[0].color
                        },
                        data: this.data.data[0].value
                    },
                    {
                        type: 'bar',
                        name: this.data.data[1].name,
                        barWidth: 6,
                        barGap: 0,
                        yAxisIndex: 1,
                        itemStyle: {
                            borderRadius: 2,
                            color: this.data.data[1].color
                        },
                        data: this.data.data[1].value
                    },
                ]

            };
            if (!this.myChart) this.myChart = this.$echarts(this.$el);

            this.myChart.clear();
            this.myChart.resize()
            this.myChart.setOption(option);
        }
    },
    mounted() {
        this.setChart();
    },
}
</script>

